import {Injectable} from '@angular/core';
import {FavoriteVehicle, FavoriteAction, IVehicleMake, IVehicleModel} from '@shared/interfaces';
import {AuthState} from '@shared/state/auth/auth.state';
import {Store} from '@ngxs/store';
import moment from 'moment';
import {Database, ref, get, child, set, remove, increment, runTransaction} from '@angular/fire/database';
import {Firestore, collection, deleteDoc, setDoc, getDocs, doc} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private store: Store, private db: Database, private firestore: Firestore) {
  }

  async getMakes(): Promise<IVehicleMake[]> {
    const path = `vehicles/makes`;
    const dbRef = ref(this.db, path);
    return (await get(dbRef)).val();
  }

  async getModelsByMake(make: string): Promise<{ [k: string]: IVehicleModel[] }> {
    const path = `vehicles/models`;
    const dbRef = ref(this.db, path);
    return (await get(child(dbRef, make))).val();
  }

  async getFavoriteVehiclesId(): Promise<any> {
    const userId = this.store.selectSnapshot(AuthState.getUserID);

    if (!userId) {
      return Promise.resolve({});
    }
    const path = `savedVehicles/${userId}`;
    const dbRef = ref(this.db, path);
    return (await get(dbRef)).val();
  }

  async getFavoriteVehiclesData(): Promise<any[]> {
    const userId = this.store.selectSnapshot(AuthState.getUserID);

    if (!userId) {
      return Promise.resolve([]);
    }
    const path = `users/${userId}/savedVehicles`;
    const dataCollection = collection(this.firestore, path);
    return getDocs(dataCollection)
      .then(documents => {
        const arr: FavoriteVehicle[] = [];
        documents.forEach(_doc => {
          arr.push({
            ...this.mapDoc(_doc)
          });
        });
        return arr.reverse();
      });
  }

  async setFavoriteVehicle(vehicleId: string, vehicleData: FavoriteVehicle, action: FavoriteAction) {
    const userId = this.store.selectSnapshot(AuthState.getUserID);
    if (!userId) {
      return Promise.reject('User is not logged in');
    }
    const firestorePath = `users/${userId}/savedVehicles`;
    const rtDbPath = `savedVehicles/${userId}`;
    const timestamp = moment().format('YYYYMMDDHHmmss');

    try {
      if (action === 'delete') {
        const vehicleDoc = doc(this.firestore, firestorePath, vehicleId);
        deleteDoc(vehicleDoc);

        const dbCounterRef = ref(this.db, `carvryStats/reports/noOfSavedVehicles`);
        await runTransaction(dbCounterRef, () => increment(-1));

        const dbRef = ref(this.db, rtDbPath);
        return remove(child(dbRef, vehicleId));
      } else if (action === 'save') {
        // Doing the map to remove undefined values since firestore can't currently handle it- ignoreUndefinedProperties...
        const vehicleDoc = doc(this.firestore, firestorePath, vehicleId);
        setDoc(vehicleDoc, {
          ...vehicleData,
          updatedAt: parseInt(timestamp, 10)
        });

        const dbCounterRef = ref(this.db, `carvryStats/reports/noOfSavedVehicles`);
        await runTransaction(dbCounterRef, () => increment(1));

        const dbRef = ref(this.db, rtDbPath);
        return set(child(dbRef, vehicleId), true);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }

  mapDoc(document) {
    if (document.exists) {
      return {
        id: document.id,
        ...document.data()
      };
    }
    return null;
  }
}
